import {getPushNotificationLogByUserId} from "../../../api/graphql/pushNotification";
import {useState} from "react";
import {useRecoilState, useSetRecoilState} from "recoil";
import {
    globalHeaderPushNotificationDataState,
    globalUnreadPushNotificationCountState
} from "../../../_common/global_state";

export const useGetHeaderPushNotificationLogByUserId = () => {
    const setUnreadPushNotificationCount = useSetRecoilState(globalUnreadPushNotificationCountState);
    const [data, setData] = useRecoilState(globalHeaderPushNotificationDataState)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    const fetchLog = async () => {
        try {
            setLoading(true)
            const id = localStorage.getItem("userid")
            const {getPushNotificationLogByUserId: res} = await getPushNotificationLogByUserId(id, 8, 0)

            setData(res?.data)
            setUnreadPushNotificationCount(res?.unreadTotal)
            setTotal(res?.total)
            setLoading(false)
        } catch (e) {

        }
    }

    return [data, total, fetchLog, loading]
}